import { render, staticRenderFns } from "./NeutralAlert.vue?vue&type=template&id=67787d8e&scoped=true&"
import script from "./NeutralAlert.vue?vue&type=script&lang=js&"
export * from "./NeutralAlert.vue?vue&type=script&lang=js&"
import style0 from "./NeutralAlert.vue?vue&type=style&index=0&id=67787d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67787d8e",
  null
  
)

export default component.exports